module.exports = __webpack_public_path__ + "media/images/sec_3-2-b4f6378bc1e446b29bf19f54fbc4d024.png";